module.exports = __webpack_public_path__ + "img/page-under-construction-dark.bd40ae1e.svg";